export const getIndexValidationText = (index: string, optionalIndex?: boolean): string => {
    if (index.length > 0 && index.length < 6) {
        return "Значение должно состоять из 6 цифр";
    } else if (index.length > 6) {
        return "Значение должно быть целым числом длиной не более 6 цифр";
    } else if (!optionalIndex && index.length === 0) {
        return "Поле должно быть заполнено";
    } else {
        return "";
    }
};
